export default __webpack_public_path__ + "static/media/firefox-icon.99f170f7.svg";